import styled from "styled-components";
import { colors } from "common/const/colors";
import {
  textStyleBody2,
  textStyleButton2,
  textStylePlaceholder,
} from "common/components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  width: 100%;
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  border: 1px solid ${colors.Gray};
  border-radius: 8px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: ${({ $columns }) => $columns};
  width: fit-content;
  min-width: 100%;

  & [data-row]:hover,
  & [data-row]:hover ~ [data-row] {
    background-color: ${colors.LightGray};
  }
`;

export const Th = styled.div`
  ${textStyleButton2}
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: ${colors.LightGray};
  white-space: nowrap;
`;

export const ThLabel = styled.span`
  position: relative;
`;

export const Td = styled.div`
  ${textStyleBody2}
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  min-width: 0;
  background-color: ${({ $hovered }) =>
    $hovered ? colors.LightGray : "transparent"};
`;

export const TdContent = styled.span`
  white-space: normal;
  justify-content: center;
  align-items: center;
  text-align: center;

  ${({ $isEllipsis }) =>
    $isEllipsis
      ? `
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  `
      : `
    width: 100%;
    min-width: 0;
        overflow-wrap: break-word;
    word-break: break-word;
  `};
`;

export const AdditionalTh = styled(Th)``;

export const AdditionalTd = styled(Td)`
  overflow: visible;
`;

export const EmptyRow = styled.div`
  ${textStyleBody2}
  grid-column: span ${({ $span }) => $span};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  color: ${colors.LightNavy};
`;

export const Divider = styled.div`
  grid-column: span ${({ $span }) => $span};
  border-bottom: 1px solid ${colors.LightGray};
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
`;

export const PageButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 1.5rem;
  height: 1.25rem;
  border: none;
  background: none;
  color: ${({ $active }) => ($active ? colors.MainBlue : colors.LightNavy)};
  cursor: pointer;
  ${({ $active }) => ($active ? textStyleButton2 : textStylePlaceholder)};

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const getPageNumbers = (currentPage, totalPages) => {
  const pages = [];
  const maxVisible = 5;

  if (totalPages <= maxVisible + 2) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
    return pages;
  }

  pages.push(1);

  let start = Math.max(2, currentPage - 1);
  let end = Math.min(totalPages - 1, currentPage + 1);

  if (currentPage <= 3) {
    start = 2;
    end = maxVisible;
  } else if (currentPage >= totalPages - 2) {
    start = totalPages - maxVisible + 1;
    end = totalPages - 1;
  }

  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < totalPages - 1) pages.push("...");

  pages.push(totalPages);
  return pages;
};
